import { AUDIO_STATUS } from "./Constants";

export const defaultLDFlags = {
    "survey-monkey": false,
    "save-chat-history": false,
    "markup-with-blur": false,
    "capture-device-and-google-event": false,
    "callstats-io-integration": false,
    "start-live-pointer-automatically": false,
    "hide-start-video-button": false,
    "delete-image-during-call": false,
    "scan-code": false,
    "popup-on-disconnect": false,
    "live-caption": false,
    "idle-logout": false,
    "skip-connect-button": false,
    "help-view": false,
    "room-call-logs": false,
    "cb-for-blitzz-portal": false,
    "mic-button-status": AUDIO_STATUS.ENABLED_FOR_THE_AGENT_AND_GUEST_BOTH,
    "hide-mediate-button": false,
    "privacy-policy-unchecked": true,
    "ask-ai-assistant": false,
};
export const ARTICLES_NUMBER = {
    LOCATION_PERMISSION_ARTICLES_NUMBER: "44001949900-reset-browser-permissions",
    BROWSER_REQUIRED_TO_CONNECT_CALL_ARTICLES_NUMBER: "44001950048-minimum-system-requirements-hardware-and-software",
    COMMON_ARTICLES_NUMBER: "44002028830",
    FIREFOX_ARTICLES_NUMBER: "44002028843",
    SAFARI_MAC_ARTICLES_NUMBER: "44002028839",
    SAFARI_MOBILE_TAB_ARTICLES_NUMBER: "44002028840",
    EDGE_ARTICLES_NUMBER: "44002028827",
    SAMSUNG_INTERNET_ARTICLES_NUMBER: "44001949916",
    MOBILE_CHROME_ARTICLES_NUMBER: "44002028836",
    DESKTOP_CHROME_ARTICLES_NUMBER: "44002028837",
    IOS_APP_ARTICLES_NUMBER: "44002038379",
    ANDROID_APP_ARTICLES_NUMBER: "44002038353",
    MEASUREMENT_APP_ARTICLES_NUMBER: "44001949990-download-mobile-app",
};
export const SOLUTION_ARTICLE_LINK = "https://help.blitzz.co/support/solutions/articles/";

export const HELP_ARTICLE = {};
